import { MentionProvider } from '@atlaskit/mention/types';

import { ConversationsMentionContext } from 'src/components/bbc-atlaskit-editor/src/types/ConversationsMentionContext';
import {
  MentionsBuildArgs,
  UserRecommendationsMentionProvider,
} from 'src/components/editor/providers/recommendations-mentions-provider';

function userMentionProvider(
  fallbackMentionBuilderArgs: MentionsBuildArgs,
  conversationsMentionContext: ConversationsMentionContext
) {
  return new UserRecommendationsMentionProvider(
    fallbackMentionBuilderArgs,
    conversationsMentionContext
  );
}

// This returns a promise for the MentionProvider which is used
// in the ProviderFactory for retrieving at-mentions recommendations data
export function createMentionProvider({
  owner,
  slug,
  intl,
  conversationsMentionContext,
}: MentionsBuildArgs & {
  conversationsMentionContext: ConversationsMentionContext;
}): Promise<MentionProvider> | undefined {
  return Promise.resolve(
    userMentionProvider({ owner, slug, intl }, conversationsMentionContext)
  );
}
